import React, { LegacyRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const VideoPersonSparkle = React.forwardRef<
  SVGElement,
  { fillColor?: string } & SvgProps
>(({ fillColor = '#212121', ...props }, ref) => {
  return (
    <Svg
      ref={ref as LegacyRef<Svg>}
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <Path
        d='M4.297 4h15.449A2.252 2.252 0 0122 6.249v11.502A2.249 2.249 0 0119.75 20H4.25A2.25 2.25 0 012 17.751v-7.207c.063.074.133.141.21.2a1.384 1.384 0 001.29.143v6.861a.75.75 0 00.75.75h2.749v-2.753a1.749 1.749 0 011.607-1.743l.143-.006h6.495a1.75 1.75 0 011.744 1.606l.006.143v2.749h2.752a.75.75 0 00.75-.75V6.249a.75.75 0 00-.75-.75H5.418l-.281-.09a.891.891 0 01-.564-.56L4.297 4zm4.197 14.494h7l-.005-2.75a.25.25 0 00-.193-.242l-.057-.007H8.744a.25.25 0 00-.243.193l-.007.057v2.749zm5.627-10.616a2.998 2.998 0 01-3.27 4.89A3.002 3.002 0 019 9.999 2.998 2.998 0 0112 7a3 3 0 012.121.878zm-3.182 1.06a1.499 1.499 0 102.12 2.12 1.499 1.499 0 00-2.12-2.12zm-8.578-.1l.3.917a.363.363 0 00.676.023l.008-.023.3-.916a1.888 1.888 0 011.199-1.197l.918-.3a.363.363 0 000-.684h-.018l-.919-.3a1.882 1.882 0 01-1.198-1.197l-.3-.918a.364.364 0 00-.552-.175.364.364 0 00-.132.175l-.3.917-.007.023a1.892 1.892 0 01-1.173 1.175l-.919.3a.364.364 0 00-.175.55.36.36 0 00.175.134l.919.3a1.9 1.9 0 011.198 1.197zm2.53 1.71l.536-.175a1.118 1.118 0 00.587-.472c.041-.071.075-.147.1-.226l.174-.536a.217.217 0 01.12-.124.21.21 0 01.202.024.222.222 0 01.077.102l.174.536a1.099 1.099 0 00.7.698l.535.174h.01a.213.213 0 01.141.2.211.211 0 01-.139.199l-.535.174a1.1 1.1 0 00-.7.699l-.173.534a.22.22 0 01-.078.1.212.212 0 01-.321-.1l-.174-.534a1.1 1.1 0 00-.7-.702l-.535-.174a.213.213 0 01-.1-.32.2.2 0 01.1-.078z'
        fill={fillColor}
      />
    </Svg>
  )
})

VideoPersonSparkle.displayName = 'VideoPersonSparkle'

export default VideoPersonSparkle
